var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{attrs:{"options":_vm.options,"lang":"xml","width":"100%","height":"500"},on:{"init":_vm.editorInit},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }